import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {tap} from 'rxjs/operators';
import { Store} from '@ngrx/store';
import {authLoginSuccess, authLogout} from '../auth/auth.actions';
import {EmployeeService} from './employee-service';
import {employeeReset, employeeSave} from './employee.action';

@Injectable()
export class EmployeeEffects {
  fetchOnLoginSuccess = createEffect(
      () =>
          this._actions$.pipe(
              ofType(authLoginSuccess),
              tap(() => {
                    this._employeeService.fetchCurrentEmployeeInfo().subscribe(
                        (employeeState) => {
                          this._store.dispatch(employeeSave({ employeeState }));
                        }
                    );
                  }
              )
          ),
      {dispatch: false}
  );

  resetOnLogout = createEffect(
      () =>
          this._actions$.pipe(
              ofType(authLogout),
              tap(() => {
                  this._store.dispatch(employeeReset());
                  }
              )
          ),
      {dispatch: false}
  );

  constructor(
      private _actions$: Actions,
      private _store: Store<any>,
      private _employeeService: EmployeeService
  ) {
  }

}
